var React = require('react');

function NavIconsCustomNodes (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m3 3v18.1h18.1v-18.1zm17.08 17.08h-16.16v-16.16h16.16zm-4.51-8.92v6.21h1v-6.2a1.76 1.76 0 0 0 0-3.4v-1.23h-1v1.24a1.76 1.76 0 0 0 0 3.38zm.51-2.42a.73.73 0 0 1 .72.73.72.72 0 0 1 -.72.72.72.72 0 1 1 0-1.44zm-4.56 6.31v2.31h1v-2.3a1.76 1.76 0 0 0 0-3.39v-5.13h-1v5.14a1.75 1.75 0 0 0 0 3.37zm.48-2.41a.73.73 0 0 1 .73.73.73.73 0 0 1 -1.45 0 .72.72 0 0 1 .72-.72zm-4.53.36v4.38h1v-4.38a1.76 1.76 0 0 0 0-3.38v-3.08h-1v3.06a1.75 1.75 0 0 0 0 3.38zm.53-2.43a.73.73 0 0 1 .72.73.72.72 0 1 1 -.72-.72z"}));
}

NavIconsCustomNodes.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = NavIconsCustomNodes;

NavIconsCustomNodes.default = NavIconsCustomNodes;
